module.exports = __webpack_public_path__ + "img/uklonjena3.6673c94b.jpg";